import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const CustomeTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 140,
    fontSize: theme.typography.pxToRem(12),
  },
}));

export default function CustomizedTooltips({ children, forceOpen, setForceOpen }) {
  return (
    <div
      onMouseEnter={() => setForceOpen(true)}
      onMouseLeave={() => setForceOpen(false)}
      onTouchStart={() => setForceOpen(true)}
      onTouchEnd={() => setForceOpen(false)}
      onClick={() => setForceOpen(false)}
      onFocus={() => setForceOpen(false)}
    >
      <CustomeTooltip
        arrow
        placement="top"
        open={forceOpen}
        onClose={() => setForceOpen(false)}
        onOpen={() => setForceOpen(true)}
        disableHoverListener
        disableFocusListener
        disableTouchListener
        title={"Use tags to make your post discoverable"}
      >
        {children}
      </CustomeTooltip>
    </div>
  );
}
